<template>
  <div class="page">
    <app-title
      :page="'Index'"
      :prehead="'Nimber Manual'">
      <app-manual-nav slot="content"/>
    </app-title>
    <section class="grid">
      <h2/>
    </section>
  </div>
</template>

<script>
import Title from '../common/Title'
import ManualNav from './ManualNav'

export default {
  components: {
    appTitle: Title,
    appManualNav: ManualNav
  }
}
</script>
